import type { Category } from '@/types/tv';

export const categories: Category[] = [
  {
    slug: 'guochan',
    name: '国产剧',
    desc: '精选口碑与评分俱佳的国产剧集，涵盖古装、年代、都市与悬疑等题材，用扎实的剧本与表演呈现东方叙事之美。',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'oumei',
    name: '欧美剧',
    desc: '汇聚英美及欧洲高分剧集，从悬疑犯罪到科幻史诗，制作精良、叙事紧凑，是资深剧迷的必看清单。',
    icon: 'ri-global-line',
  },
  {
    slug: 'rihan',
    name: '日韩剧',
    desc: '精选日韩地区高口碑作品，细腻的情感刻画与独特的类型表达，兼具治愈与张力。',
    icon: 'ri-earth-line',
  },
  {
    slug: 'guzhuang',
    name: '古装剧',
    desc: '以历史与架空世界为背景的古装佳作，恢弘的服化道与权谋叙事，带你重回风云年代。',
    icon: 'ri-ancient-gate-line',
  },
  {
    slug: 'xuanyi',
    name: '悬疑剧',
    desc: '层层反转、悬念迭起的悬疑与推理剧集，考验你的观察力与推理能力。',
    icon: 'ri-search-eye-line',
  },
  {
    slug: 'kehuan',
    name: '科幻剧',
    desc: '面向未来的科幻与奇幻剧集，宏大的世界观设定与深刻的人文思考并存。',
    icon: 'ri-planet-line',
  },
  {
    slug: 'aiqing',
    name: '爱情剧',
    desc: '细腻动人的爱情剧集，记录心动、错过与重逢，适合安静追完的深夜时光。',
    icon: 'ri-heart-3-line',
  },
  {
    slug: 'fanzui',
    name: '犯罪剧',
    desc: '聚焦罪案与人性博弈的犯罪题材，节奏紧张、氛围冷峻，代入感极强。',
    icon: 'ri-shield-user-line',
  },
  {
    slug: 'xiandai',
    name: '现代剧',
    desc: '贴近现实生活的都市与年代现代剧，于柴米油盐中看见时代与人心。',
    icon: 'ri-building-2-line',
  },
];

export const navCategories: Category[] = [
  categories[0],
  categories[1],
  categories[2],
  categories[3],
  categories[4],
  categories[5],
];